import {BaseMyopMessage, MyopBindMessage, MyopBindReplayMessage} from "./BaseMessage";
import {IElementRef} from "../common";

const ReplayMessageKey = 'DetectedMyopRefsMessage'

export class DetectMyopRefsMessage extends MyopBindMessage<any, DetectedMyopRefsMessage> {
    messageType = 'DetectMyopRefsMessage'
    replyMessageKey = ReplayMessageKey;
}

export class DetectedMyopRefsMessage extends MyopBindReplayMessage<IElementRef[]> {

    messageType = ReplayMessageKey;

    constructor(public replayToHandler: string, myopElementRefs: IElementRef[]) {
        super(replayToHandler)
        this.content = myopElementRefs;
    }

    isTypeof(msg: BaseMyopMessage<any>): boolean {
        return msg.messageType === this.messageType
    }
}
